import { ShieldCheck, ShieldWarning, FirstAid } from "@phosphor-icons/react";
import { InfoHint } from "./InfoHint";

const cfg = {
  ok: { icon: ShieldCheck, color: "#00e676", title: "Признаков болезни нет", border: "border-border/60" },
  warning: { icon: ShieldWarning, color: "#ffea00", title: "Будьте внимательны", border: "border-[#ffea00]/40" },
  alert: { icon: FirstAid, color: "#ff3b30", title: "Организм борется", border: "border-[#ff3b30]/50" },
};

export default function IllnessCard({ risk }) {
  if (!risk) return null;
  const c = cfg[risk.level];
  const Icon = c.icon;
  return (
    <div className={`glass-card p-5 ${c.border}`} data-testid="illness-card">
      <div className="flex items-center gap-2 mb-1">
        <Icon size={18} weight="fill" style={{ color: c.color }} />
        <h3 className="text-sm font-semibold">Детектор ранних признаков болезни<InfoHint text="Отслеживает отклонения температуры кожи, пульса покоя, HRV и частоты дыхания от вашей личной нормы. Несколько сигналов одновременно часто предшествуют болезни за 1–2 дня." /></h3>
        <span className="ml-auto text-xs num font-bold" style={{ color: c.color }} data-testid="illness-score">{risk.score}/{risk.total}</span>
      </div>
      <p className="text-sm font-semibold mb-1" style={{ color: c.color }}>{c.title}</p>
      <p className="text-xs text-muted-foreground leading-relaxed mb-3">{risk.text}</p>
      <div className="grid grid-cols-2 gap-2">
        {risk.markers.map((m) => (
          <div key={m.key} data-testid={`illness-marker-${m.key}`}
            className={`rounded-md px-2.5 py-2 text-xs flex items-center justify-between ${m.flagged ? "bg-[#ff3b30]/10 border border-[#ff3b30]/30" : "bg-secondary/50"}`}>
            <span className="text-muted-foreground">{m.label}</span>
            <span className={`num font-semibold ${m.flagged ? "text-[#ff3b30]" : ""}`}>
              {m.current} <span className="text-muted-foreground font-normal">/ база {m.baseline}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
